/**
 * Dunning history contracts (M22).
 *
 * Failed-payment retry audit log shapes used by:
 *   GET /subscription/dunning-history       — list rows for the current tenant
 *
 * Backed by `platform.dunning_history` (migration 0045).
 */
import { z } from 'zod';

export const DunningStatusEnum = z.enum(['failed', 'succeeded', 'final_failure']);
export type DunningStatusValue = z.infer<typeof DunningStatusEnum>;

export const DunningHistoryEntrySchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  subscriptionId: z.string().uuid(),
  attemptNumber: z.number().int().nonnegative(),
  attemptedAt: z.string(),
  status: DunningStatusEnum,
  failureReason: z.string().nullable(),
  nextRetryAt: z.string().nullable(),
  notificationSent: z.boolean(),
  createdAt: z.string(),
});
export type DunningHistoryEntry = z.infer<typeof DunningHistoryEntrySchema>;

export const ListDunningHistoryQuerySchema = z.object({
  status: DunningStatusEnum.optional(),
  limit: z.coerce.number().int().min(1).max(500).optional(),
});
export type ListDunningHistoryQuery = z.infer<typeof ListDunningHistoryQuerySchema>;

export const ListDunningHistoryResponseSchema = z.object({
  items: z.array(DunningHistoryEntrySchema),
});
export type ListDunningHistoryResponse = z.infer<typeof ListDunningHistoryResponseSchema>;
